













import { UwInput } from '@ultraware/vee-form-handler'
import { QInput } from 'quasar'
import { ValidationProvider } from 'vee-validate'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  inheritAttrs: false,
  components: { UwInput, QInput, ValidationProvider },
})
export default class FormattedPriceInput extends Vue {
  @Prop({ required: true }) public value!: number
  private tmpValue: number | null = null // Attention! dont make tmpValue reactive

  get amount(): string {
    if (this.value === null || isNaN(this.value)) {
      return ''
    }

    return this.centsToEuro(this.value)
  }

  set amount(amount: string) {
    if (amount === '') {
      this.tmpValue = null
      return
    }

    this.tmpValue = Math.round(Number(amount.replace(',', '.')) * 100)
  }

  public onChange(): void {
    if (this.tmpValue !== null && isNaN(this.tmpValue)) {
      this.tmpValue = null
    }

    this.$emit('input', this.tmpValue)
  }

  public centsToEuro(value: number): string {
    return String((value / 100).toFixed(2)).replace('.', ',')
  }
}
